var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTowerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58158 15.8843H10.4843L9.85852 13.9772H6.207L5.58158 15.8843ZM9.2331 12.0699L8.03248 8.40897L6.83278 12.0699H9.2331ZM13.6128 19.3973L11.8333 20L11.1093 17.7915H4.95721L4.23298 20L2.45369 19.3973L6.81449 6.09652C6.69719 5.88962 6.6259 5.65207 6.6259 5.39471C6.6259 4.60512 7.25622 3.9643 8.03286 3.9643C8.80951 3.9643 9.43983 4.60512 9.43983 5.39471C9.43983 5.65206 9.36854 5.8896 9.2514 6.09652L13.6128 19.3973ZM13.3397 8.16932e-05L12.0125 1.34843C14.2065 3.5798 14.2065 7.20946 12.0125 9.44091L13.3397 10.7893C16.2644 7.81494 16.2644 2.97429 13.3397 0.000245235V8.16932e-05ZM4.05293 9.44083C1.85911 7.2093 1.85911 3.5798 4.05293 1.34835L2.72669 0C-0.197958 2.97416 -0.197958 7.81457 2.72669 10.789L4.05293 9.44083ZM12.7227 5.39463C12.7227 4.1205 12.2349 2.92287 11.3485 2.02359L10.0223 3.37194C10.5541 3.9117 10.8467 4.62977 10.8467 5.39463C10.8467 6.15933 10.5541 6.8774 10.0223 7.41716L11.3485 8.76551C12.2349 7.86639 12.7227 6.66856 12.7227 5.39463ZM4.71702 8.76551C3.83172 7.86639 3.34302 6.66856 3.34302 5.39463C3.34302 4.1205 3.83168 2.92287 4.71702 2.02359L6.04343 3.37194C5.51252 3.9117 5.21887 4.62977 5.21887 5.39463C5.21887 6.15933 5.51251 6.8774 6.04343 7.41716L4.71702 8.76551Z",
    fill: "#5BBAC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowerIcon);
export default __webpack_public_path__ + "static/media/TowerIcon.62dabb98c175e4fa3f9a90ef01be0284.svg";
export { ForwardRef as ReactComponent };